import type { FolderAsset } from 'models';
import { useTranslation } from 'react-i18next';
import { Breadcrumb } from 'ui';
import { AssetsFilePathItem } from './assets-file-path-item';

type P = {
  folders: FolderAsset[];
  onNavigateToParentFolder: (folder: FolderAsset) => void;
  onNavigateToRoot: () => void;
};

const AssetsFilePath = ({ folders, onNavigateToParentFolder, onNavigateToRoot }: P) => {
  const { t } = useTranslation();

  if (folders.length === 0) {
    return null;
  }

  return (
    <Breadcrumb
      items={[
        {
          key: 'root',
          title: (
            <AssetsFilePathItem isCurrent={folders.length === 0} onNavigate={onNavigateToRoot} title={t('All Files')} />
          ),
        },
        ...folders.map((folder, index) => ({
          key: folder.id,
          title: (
            <AssetsFilePathItem
              isCurrent={index === folders.length - 1}
              onNavigate={() => {
                onNavigateToParentFolder(folder);
              }}
              title={folder.name}
            />
          ),
        })),
      ]}
    />
  );
};

export default AssetsFilePath;
